const Style = {
    container: 'flex flex-col p-4 px-8 overflow-y-auto',
    title: 'text-center text-lg font-semibold mb-2',
    item: 'flex justify-between py-2 space-x-4',
    itemTitle: 'font-semibold min-w-[80px]',
    itemValue: 'm-0',
}

export default Style;